<template>
    <h4 class="card-title"><slot name="title"></slot></h4>
</template>

<script>
export default {
    data() {
        return {

        }
    },
}
</script>

<style>

</style>
